import useMediaQuery from '@mui/material/useMediaQuery'

import { useAppSelector } from '@/redux/store'
import { isMeinBuero } from '@/utils/build-env'
import { isEmailConfirmationPending } from '@/redux/ducks/subscription/isEmailConfirmationPending'
import { muiTheme } from '@/theme'
import ThemeInterface from '@/theme-interface'

const mobileQuery = (muiTheme as ThemeInterface).devices.mobile

/**
 * DO-13065: true while the logged-in user works with an unverified address (website-configurator
 * registration inside the grace period). Never true on MeinBüro, which has no DOI at all.
 */
export const useEmailConfirmationPending = (): boolean => {
  const confirmation = useAppSelector(state => state.subscription.details?.confirmation)
  return !isMeinBuero() && isEmailConfirmationPending(confirmation)
}

/**
 * Whether the desktop header shows the amber verification bar. The mobile header has its own hint
 * (layout/components/menu/header/user-header.js) and the mobile pages are not laid out against
 * `theme.menuHeight`, so the bar — and the header-height bump that comes with it — is desktop-only.
 */
export const useEmailConfirmationBar = (): boolean => {
  const pending = useEmailConfirmationPending()
  const isMobile = useMediaQuery(mobileQuery)
  return pending && !isMobile
}
